const getFiles = state => state.files.data
export default getFiles
